import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  createCoursePackageAsync,
  updateCoursePackageByIdAsync,
  allCoursePackagesAsync,
  coursePackageByIdAsync,
  updateCoursePackageStatusAsync,
  updateCoursePackageActivationAsync,
  getCoursePackagesAsync,
  goalWiseCoursePackagesAsync,
  spokenEnglishPackagesAsync,
} from "./productPackage.async";

const initialState = {
  packageLoader: false,
  packagePostData: [],
  getAllPackage: [],
  updatePackage: [],
  getPackByIdData: [],
  packageStatus: [],
  packageActivation: [],
  allPackages: [],
  packageByGoal: [],
  spokenEnglishPacks: [],
};

export const productPackageSlice = createSlice({
  name: "Product",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getCoursePackagesAsync.pending,
        createCoursePackageAsync.pending,
        allCoursePackagesAsync.pending,
        coursePackageByIdAsync.pending,
        updateCoursePackageStatusAsync.pending,
        updateCoursePackageActivationAsync.pending,
        updateCoursePackageByIdAsync.pending,
        goalWiseCoursePackagesAsync.pending,
        spokenEnglishPackagesAsync.pending
      ),
      (state) => {
        state.packageLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(spokenEnglishPackagesAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.spokenEnglishPacks = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(goalWiseCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.packageByGoal = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.allPackages = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(createCoursePackageAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.packagePostData = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(allCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.getAllPackage = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(coursePackageByIdAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.getPackByIdData = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(updateCoursePackageStatusAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.packageStatus = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(updateCoursePackageActivationAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.packageActivation = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(updateCoursePackageByIdAsync.fulfilled),
      (state, action) => {
        state.packageLoader = false;
        state.updatePackage = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getCoursePackagesAsync.rejected,
        updateCoursePackageByIdAsync.rejected,
        updateCoursePackageStatusAsync.rejected,
        updateCoursePackageActivationAsync.rejected,
        coursePackageByIdAsync.rejected,
        createCoursePackageAsync.rejected,
        allCoursePackagesAsync.rejected,
        goalWiseCoursePackagesAsync.rejected,
        spokenEnglishPackagesAsync.rejected
      ),
      (state, action) => {
        state.packageLoader = false;
      }
    );
  },
  reducers: {
    emptySubsPackage: () => initialState,
  },
});

export const { emptySubsPackage } = productPackageSlice.actions;

export default productPackageSlice.reducer;
